// @ts-expect-error untyped module icons

import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UILink from 'UIComponents/link/UILink';
import upperFirst from 'hs-lodash/upperFirst';
import { Record as ImmutableRecord } from 'immutable';
import getIn from 'immutable-less/transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
export const renderActionLabel = ({
  actionLabel,
  actionLink,
  prefix,
  useString
}) => {
  if (useString) {
    // Although string interpolation is generally discouraged (https://product.hubteam.com/docs/frontend/docs/i18n/best-practices-l10n.html#string-concatenation-interpolation),
    // Considering the simplicity of generating a numbered title, we've chosen this method rather than using an i18n method.
    // For further details, refer to the discussion in PR: https://git.hubteam.com/HubSpot/automation-ui-action-features/pull/3214
    return prefix ? `${prefix}. ${actionLabel}` : actionLabel;
  }
  const label = prefix ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "automation-ui-action-features.action-labels.with-prefix-as-node",
    options: {
      counterPrefix: prefix,
      actionLabel
    }
  }) : actionLabel;
  return actionLink ? /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: actionLink,
    children: label
  }) : /*#__PURE__*/_jsx("span", {
    children: label
  });
};
class ActionMetadata extends ImmutableRecord({
  actionTypeBasePath: null,
  category: 'UNCATEGORIZED',
  dataTestId: null,
  description: '',
  extensionDefinitions: null,
  groupDescription: null,
  icon: null,
  isBeta: false,
  isNew: false,
  isUpdated: false,
  panelDescription: '',
  routeParams: null,
  status: true,
  statusReason: null,
  subTypes: null,
  theme: 'default',
  type: null,
  typeId: null,
  updateKeyPaths: null
}, 'ActionMetadata') {
  getDescriptionString() {
    return I18n.text(this.description);
  }

  /**
   * For now, we're creating these labels by using the counter
   * label prefix algorithm to generate 1-indexed counters
   * and prefixing them to the action labels. In the future,
   * we may move to allowing customers to set these.
   *
   * This function takes an optional url to redirect to on
   * click. It wraps the label.
   *
   * The `useString` optional argument
   * will return a string over a
   * React component
   */
  getActionLabel(prefix, actionLink, useString) {
    const descriptionString = this.getDescriptionString();
    const actionLabel = upperFirst(descriptionString);
    return renderActionLabel({
      prefix,
      actionLink,
      actionLabel,
      useString
    });
  }
  matchesPath(basePath, routeParams) {
    if (this.actionTypeBasePath !== basePath) {
      return false;
    }
    if (!this.routeParams) {
      return true;
    }
    return Object.keys(this.routeParams).reduce((result, key) => result && this.routeParams !== null && this.routeParams[key] === getIn([key], routeParams), true);
  }
}
export default ActionMetadata;